import { FOOD_BENEFIT_STATES } from  'common/domain/constants';

class DelegatedCardRequestController {

  isCardRequested(card) {
    return card.state === FOOD_BENEFIT_STATES.requested;
  }

  isCardApproved(card) {
    return card.state === FOOD_BENEFIT_STATES.approved;
  }

  isCardNotApprovedAndNotRequested(card) {
    return !this.isCardRequested(card) && !this.isCardApproved(card);
  }

}

export default DelegatedCardRequestController;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/components/delegatedCardListMobile/delegatedCardRow/homeDelegatedCard/delegatedCardRequest/delegatedCardRequest.controller.js